module.exports = __webpack_public_path__ + "img/views.9b5d5947.svg";